(async () => {
  const el = document.getElementById('legal-case-page-index')

  if (!el) {
    return
  }

  const { default: clientRender } = (await import(/* webpackMode: 'eager' */ 'vue-compiler/clientRender'))

  const components = [
    {
      el,
      componentImport: () => import(/* webpackMode: 'eager' */ 'src/pages/info/legal-case-page/index.vue'),
    },
  ]

  await clientRender({ components })
})()
